import { CSSProperties } from 'react';
export const buttonStyles = {
  color: 'white',
  backgroundColor: 'rgba(0,0,0,0.4)',
  width: 'fit-content',
  height: 'fit-content',
  position: 'absolute',
  right: '20px',
  top: '30px',
  zIndex: 99,
} as CSSProperties;

export const imageButtonStyles = {
  color: 'white',
  backgroundColor: 'rgba(0,0,0,0.4)',
  width: 'fit-content',
  height: 'fit-content',
  position: 'absolute',
  left: '20px',
  bottom: '30px',
  zIndex: 99,
} as CSSProperties;

export const editStyles = {
  background: 'white',
  borderRadius: '10px',
  fontSize: '18px',
  width: 'fit-content',
  height: 'fit-content',
  position: 'absolute',
  left: '20px',
  top: '30px',
  zIndex: 99,
} as CSSProperties;
